import { type MCPServerInfo } from '../../types';

const BraveServer: MCPServerInfo = {
  serverId: 'BRAVE',
  name: 'Brave Search',
  slug: 'brave',
  description:
    'Search the Web for pages, images, news, videos, and more using the Brave Search API.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/brave-search:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['braveApiKey'],
    properties: {
      braveApiKey: {
        type: 'string',
        description: 'Brave API Key',
        sensitive: true
      }
    }
  }
};

export default BraveServer;
